module.exports = __webpack_public_path__ + "static/media/454A9209.0c0deca6.jpg";